import './App.css';
import React from "react";
import Navbar from './Components/Navbar';
import Footer from './Components/Footer'
 
/*import { Route, Link, BrowserRouter as Router } from 'react-router-dom'  */
/*import {Routes, Route } from "react-router-dom";*/
import Home from './Components/Home';
import About from './Components/About';
import Courses from './Components/Courses';
import Gallery from './Components/Gallery';
import Franchise from './Components/Franchise';
import Contact from './Components/Contact';
import Student from './Components/Student_result';

import {BrowserRouter as Router ,Route,Routes} from 'react-router-dom';


function App() {
  return (
    <>
      <div className="app" id='content'>
        <Router><Navbar />
          <Routes >
          
          {/*<Route path="/" exact component={Home} />
          <Route path="/about"  component={About} />*/}
          <Route exact path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/courses' element={<Courses />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/franchise' element={<Franchise />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/student_result' element={<Student />} />

          {/*<Home /> */}
          {/*<About />*/}
          {/*<Courses />*/}
          
         </Routes><Footer />
      </Router>
    </div>
  </>
  );
}

export default App;
